import { useMutation, UseMutationResult } from '@tanstack/react-query';

import createNote from '@/actions/notes/createNote';
import { CreateNoteRequest, Note } from '@/types/note.type';
import { ApiResponse } from '@/types/response.type';

interface CreateUserNoteMutationInput {
  payload: CreateNoteRequest;
  userId: string;
}

export interface UseCreateNoteReturn {
  mutate: (data: CreateUserNoteMutationInput) => Promise<ApiResponse<Note>>;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useCreateNote = (): UseCreateNoteReturn => {
  const mutation: UseMutationResult<
    ApiResponse<Note>,
    Error,
    CreateUserNoteMutationInput
  > = useMutation({
    mutationFn: createNote,
  });

  return {
    mutate: mutation.mutateAsync,
    error: mutation.error,
    isError: mutation.isError,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
  };
};
